// Comms channel detection (1.12.212-beta): the small badges on the thread header and the contact card —
// "Mobile" / "Landline" / "VoIP" and "On WhatsApp" / "Not on WhatsApp" — plus "Check now" and, for a number marked
// Not on WhatsApp, "Try WhatsApp again". Badges always carry words (colour is never the only signal).
import React from 'react';
import StatusChip from '../ui/StatusChip';
import { channelBadges, whatsappCapability } from '../../lib/channelCapability';

export default function PhoneChannelBadges({
    capability = null,
    checking = false,
    notice = '',
    onCheckNow,
    onTryWhatsAppAgain,
    canAct = true,
    className = '',
}) {
    const badges = channelBadges(capability);
    const notOnWhatsApp = whatsappCapability(capability).state === 'not_on';
    if (!badges.length && !onCheckNow) return null;
    return (
        <div className={`flex min-w-0 flex-wrap items-center gap-1.5 ${className}`} data-phone-channel-badges="true">
            {badges.map((badge) => (
                <StatusChip key={badge.key} tone={badge.tone} title={badge.title}>
                    <span data-channel-badge={badge.key}>{badge.label}</span>
                </StatusChip>
            ))}
            {canAct && onCheckNow && (
                <button
                    type="button"
                    className="ia-btn3d ia-comms-pill ia-phone-check-now"
                    onClick={onCheckNow}
                    disabled={checking}
                    aria-busy={checking ? 'true' : undefined}
                    title="Ask Twilio what kind of line this number is (about $0.008)"
                    data-phone-check-now="true"
                >
                    {checking ? 'Checking…' : 'Check now'}
                </button>
            )}
            {canAct && notOnWhatsApp && onTryWhatsAppAgain && (
                <button type="button" className="ia-btn3d ia-comms-pill" onClick={onTryWhatsAppAgain} data-whatsapp-try-again="true">
                    Try WhatsApp again
                </button>
            )}
            {notice && <span className="text-xs" role="status" data-phone-check-notice="true">{notice}</span>}
        </div>
    );
}
